import { changeThemeWordsStateRecursive, resetChildItemsStatuses } from './helpers.js'

export default {  
  INITIAL_LOAD: (state, value) => {
    state.initialLoad = value;
  },
  TUKA_READY: (state, value) => {
    state.tukaReady = value;
  },
  INIT_PORTLET_ID: (state, portletId) => {
    state.portletId = portletId;
  },
  INIT_CONTAINER_ID: (state, containerId) => {
    state.containerId = containerId;
  },
  SET_TIME: (state, time) => {
    state.time = time;
  },
  SET_VISIBLE_CONTENT_ID: (state, id) => {
    state.dataContent.visibleContentId = id;
  },
  SET_SETTINGS: (state, data) => {
    state.dataContent.settings = data;
  },
  SET_HASH: (state, hash) => {
    state.dataContent.hash = hash;
  },
  SET_SCROLLING_RESERVED: (state, reserved) => {
    state.scrollingReserved = reserved;
  },
  SET_MAIN_CONTENT_HAS_ITEMS_WITH_ACTIVE_THEME_WORDS: (state, value) => {
    state.dataContent.mainContentHasItemsWithActiveThemeWords = value
  },
  SET_THEME_WORDS: (state, themeWords) => {
    state.dataContent.themeWords = themeWords;
    
    let themeWordsActive = false;
    for (let name in themeWords) {
      if (themeWords[name]) themeWordsActive = true;
    }
    // Set filter "themeWords" state to true/false
    state.dataContent.filters.themeWords = themeWordsActive;
  },
  CHANGE_SIDEBAR_THEME_WORDS_STATE: (state, themeWords) => {
    let sidebar = state.dataContent.sidebar[0];

    // Reset sidebar items themewords-related state
    resetChildItemsStatuses(sidebar);

    // Modify sidebar items themewords-related state
    changeThemeWordsStateRecursive(themeWords, sidebar);
    
  },
  CHANGE_MAIN_CONTENT_THEME_WORDS_STATE: (state, themeWords) => {
    let mainContent = state.mainContent;

    for (let singleItem of mainContent) {
      changeThemeWordsStateRecursive(themeWords, singleItem);
    }
    
  },
  /**
   * @description change the targetId to correspond clicked button id.
   * targetId filters returned data to right column
   * @param {HTMLButtonElement} clickedButton clicked Button
   */
  MOVE_DATA: (state, clickedButton) => {
    state.targetId = clickedButton.target.id;
  },
  UPDATE_CURRENT_ITEM_LOCATION_DATA: (state, payload) => {
    state.dataContent.currentItemLocationData = payload.location;
  },
  SET_MAIN_CONTENT: (state, data) => {
    state.mainContent = data;
  },
  SET_SIDEBAR_CONTENT: (state, data) => {
    state.dataContent.sidebar = data.sidebar;
  },
  SET_SEARCH_RESULTS: (state, data) => {
    state.searchResults = data;
  },
  SET_TEXT_SEARCH_VALUE: (state, data) => {
    state.textSearchValue = data;
  },
  SET_TEXT_SEARCH_STATIC_VALUE: (state, data) => {
    state.textSearchStaticValue = data;
  },
  SET_WARNINGS: (state, data) => {
    state.warnings = data;
  },
  INIT_COMPONENT_DATA: (state) => {
    state.targetId = "initial";
  },
  INIT_THEME_WORDS: (state, themeWords) => {
    state.dataContent.themeWords = themeWords;
  },
  INIT_ROOT_ITEM: (state, rootItem) => {
    state.dataContent.rootItem = rootItem;
  },
  SET_HEADERS_WITHOUT_ORDER_NUM: (state, payload) => {
    state.headersWithoutOrderNum.push(payload);
  }
};
